import { TestXDataStore } from "./TestXDataStore";
import { IDataStoreFactory } from "./IDataStoreFactory";
import { IDataStore } from "./IDataStore";
import { IBaseDataObject } from "./BaseDataObject";
import type { AppGlueAny } from "../../Common/AppGlueAny";

export class TestDataStoreFactory implements IDataStoreFactory {
    private static testDataStores: {
        collectionName: string;
        dataStore: AppGlueAny;
    }[] = [];

    public static clearTestData() {
        for (let f of TestXDataStore.clearFunctions) {
            f();
        }
    }

    getDataStoreByName<T extends IBaseDataObject>(collectionType: string): IDataStore<T> | undefined {
        // lookup data store
        for (let ds of TestDataStoreFactory.testDataStores) {
            if (ds.collectionName === collectionType) {
                return ds.dataStore as IDataStore<T>;
            }
        }

        // there is no data store, create one
        let retds = new TestXDataStore<T>(collectionType);

        TestDataStoreFactory.testDataStores.push({
            collectionName: collectionType,
            dataStore: retds,
        });

        return retds;
    }
}
